import { createFileRoute } from '@tanstack/react-router'

import { ExpenseImportPage } from '@/pages/expenses/import/ExpenseImportPage'

export const Route = createFileRoute('/_authenticated/_dashboard/expenses/import/')({
  component: ExpenseImportPage,
})
